<template>
  <v-card class="create-a-sor">
    <v-card-title class="justify-center">
      {{ $t('work_order.create_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row>
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.contract_id') }}
          </v-col>
          <v-col cols="9"
                 class="input-control">
            <v-text-field outlined
                          disabled
                          hide-details="auto"
                          :value="contractId"></v-text-field>
          </v-col>
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.contract_year') }}
          </v-col>
          <v-col cols="9"
                 class="input-control">
            <v-select outlined
                      hide-details="auto"
                      :items="contractYearOptions"
                      v-model="contractYear"
                      :rules="requiredRules"></v-select>
          </v-col>
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.name') }}
          </v-col>
          <v-col cols="9"
                 class="input-control">
            <v-text-field outlined
                          hide-details="auto"
                          v-model="name"
                          :rules="requiredRules"></v-text-field>
          </v-col>
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.work_order_no') }}
          </v-col>
          <v-col cols="9"
                 class="input-control">
            <v-text-field outlined
                          hide-details="auto"
                          v-model="work_order_no"
                          :rules="requiredRules"></v-text-field>
          </v-col>
          <v-col cols="3"
                 class="input-label"
                 v-if="!isEstimate">{{ $t('work_order.nature') }}
          </v-col>
          <v-col cols="9"
                 class="input-control"
                 v-if="!isEstimate">
            <v-autocomplete outlined
                            hide-details="auto"
                            :items="natureOptions"
                            v-model="nature"
                            :rules="requiredRules"></v-autocomplete>
          </v-col>
          <!--          <v-col cols="3"></v-col>-->
          <!--          <v-col cols="9"-->
          <!--                 class="input-control">-->
          <!--            <v-checkbox hide-details="auto"-->
          <!--                        :label="$t('work_order.is_estimate')"-->
          <!--                        v-model="isEstimate"-->
          <!--                        :disabled="csvFile"></v-checkbox>-->
          <!--          </v-col>-->
        </v-row>
        <v-row v-if="!isEstimate">
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.csv') }}
          </v-col>
          <v-col cols="9"
                 class="input-control">
            <FileInput v-model="csvFile"></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && confirm()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {onMounted, ref, computed} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import FileInput from "@/components/FileInput";

export default {
  name: 'CreateWorkOrderDialog',
  components: {FileInput},
  props: {
    contractId: String,
    isEstimate: Boolean,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required'),
    ]);

    const contractYears = ref([]);
    const getContractYears = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/year/',
        params: {
          contract_id: props.contractId,
        },
      });

      if (response.body.success) {
        contractYears.value = response.body.years;
      }
    }
    const contractYearOptions = computed(() => {
      return contractYears.value.map((y) => y.year);
    })
    const contractYear = ref(null);
    const work_order_no = ref(null);
    const name = ref('');
    const nature = ref(null);
    const natureOptions = ref([
      {text: root.$t('work_order_nature.P_ORDER'), value: 'P_ORDER'},
      {text: root.$t('work_order_nature.B_ORDER'), value: 'B_ORDER'},
      {text: root.$t('work_order_nature.E_ORDER'), value: 'E_ORDER'},
    ]);
    const csvFile = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append('contract_id', props.contractId);
      formData.append('contract_year', contractYear.value);
      formData.append('work_order_no', work_order_no.value);
      formData.append('name', name.value);
      if (csvFile.value) {
        formData.append('csv', csvFile.value, csvFile.value.name);
        formData.append('is_estimate', false);
      } else {
        formData.append('is_estimate', props.isEstimate);
      }
      if (!props.isEstimate) {
        formData.append('nature', nature.value);
      }


      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/work_order/create/',
        params: formData,
      });

      if (response.body.success) {
        emit('submit', response.body.work_order.id)
      }
    }

    onMounted(() => {
      getContractYears()
    })

    return {
      requiredRules,

      contractYearOptions,
      contractYear,
      work_order_no,
      name,
      nature,
      natureOptions,
      csvFile,

      confirm,
    }
  },
}
</script>

<style lang="less">
.create-a-sor {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
    align-self: center;
  }

  .input-control {

  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
